import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=2d0fff96"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=2d0fff96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports